import React from "react";
import { isMobile } from "../utility/constand";

const NumberAndTextShow = React.memo(({ bigtext, smalltext, nextrowtext }) => {
  return (
    <div>
      <div
        style={{
          fontFamily: "nohemi-bold",
          fontSize: isMobile ? "2rem" : "3rem",
          fontWeight: "500",
          lineHeight: isMobile ? "2rem" : "5rem",
          letterSpacing: isMobile ? "1px" : "5px",
          textAlign: "center",
          color: "#ffffff",
          margin: "0rem",
        }}
      >
        {bigtext}
        <span
          style={{
            fontSize: isMobile ? "2rem" : "2.5rem",
            lineHeight: "4rem",
            letterSpacing: "2.6px",
            textAlign: "center",
            color: "rgba(255, 255, 255, 0.5)",
          }}
        >
          { smalltext}
        </span>
      </div>
      <div
        style={{
          fontFamily: "sans-serif",
          color: "rgba(255, 255, 255, 0.7)",
          fontWeight: "400",
          fontSize: isMobile ? "1rem" : "1rem",
          lineHeight: isMobile ? "1.5rem" : "2rem",
          letterSpacing: "0.78px",
          textAlign: "center",
        }}
      >
        {nextrowtext}
      </div>
    </div>
  );
});

export default NumberAndTextShow;
